function generateSessionId() {
    const prefix = 'Sb';
    
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    
    const timestamp = `${year}${month}${day}T${hours}${minutes}${seconds}`;
    
    const randomNumber = String(Math.floor(Math.random() * 1000000)).padStart(6, '0');
    
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < 12; i++) {
      randomString += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    
    return `${prefix}_${timestamp}_${randomNumber}-${randomString}`;
  }
  
  export default generateSessionId;
  